export enum GoalOverviewManagerTableColumn {
    NAME,
    GOAL_COUNT,
    ACTIVE_GOAL_COUNT,
    COMPLETE_GOAL_COUNT,
    AVERAGE_COMPLETION,
    ACTIONS
}